import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { ErneLogo } from './ambassador/ErneLogo';
import { INK, IMG, DISPLAY, CATEGORIES } from './ambassador/data';

const reveal = (i = 0) => ({
  initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, amount: 0.3 },
  transition: { delay: i * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] },
});

export const ErneTeaser = () => (
  <section className="erne-root relative overflow-hidden text-white" style={{ background: INK }} data-testid="home-erne-section">
    <div className="absolute inset-0" style={{ background: 'radial-gradient(900px 500px at 85% 100%, rgba(181,255,0,0.16), transparent 70%)' }} />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 lg:py-20 grid lg:grid-cols-12 gap-10 lg:gap-6 items-center">
      <div className="lg:col-span-7 relative z-10">
        <motion.div {...reveal(0)} className="w-full max-w-[460px]">
          <ErneLogo dark className="w-full" testId="home-erne-logo" />
        </motion.div>
        <motion.h2 {...reveal(2)} className="mt-8 font-black uppercase leading-[0.92] tracking-[-0.02em] text-3xl sm:text-4xl lg:text-5xl" style={DISPLAY} data-testid="home-erne-heading">
          India's Under-21 players.<br /><span className="erne-grad-text">One paddle, on us.</span>
        </motion.h2>
        <motion.p {...reveal(3)} className="mt-6 max-w-lg text-base text-white/65 leading-relaxed">
          The Erne is pickleball's most brilliant shot. THE ERNE is DYSSC's fellowship for young players who play that way.
          If you're a player to watch out for, you earn a <span className="text-white font-semibold">HexCore</span> or a <span className="text-white font-semibold">ProFoam</span>.
        </motion.p>
        <motion.div {...reveal(4)} className="mt-8 flex flex-wrap items-center gap-4">
          <Link to="/erne" className="group inline-flex items-center gap-3 rounded-full pl-7 pr-2 py-2 text-sm font-bold uppercase tracking-[0.18em] text-[#090A0C] erne-grad transition-transform hover:-translate-y-0.5" data-testid="home-erne-cta">
            Enter The Erne
            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white transition-transform group-hover:rotate-45" style={{ background: INK }}><ArrowUpRight className="w-4 h-4" /></span>
          </Link>
          <div className="flex gap-2" data-testid="home-erne-categories">
            {CATEGORIES.map((c) => <span key={c.code} className="rounded-full border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70">{c.label}</span>)}
          </div>
        </motion.div>
        <motion.p {...reveal(5)} className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-white/55" data-testid="home-erne-free-paddle">
          <span className="erne-grad-text font-bold">Free paddle</span> · No fees, ever
        </motion.p>
      </div>
      <div className="lg:col-span-5 relative flex justify-center lg:justify-end lg:-my-20 lg:self-stretch" data-testid="home-erne-poster">
        <motion.div
          initial={{ opacity: 0, y: -60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="relative w-[240px] sm:w-[300px] lg:w-[340px] -mt-10 lg:mt-0"
        >
          <div className="absolute left-1/2 top-[58%] -translate-x-1/2 -translate-y-1/2 w-[120%] aspect-square rounded-full opacity-70 blur-3xl" style={{ background: 'radial-gradient(closest-side, rgba(181,255,0,0.32), transparent)' }} />
          <motion.img
            src={IMG.medal} alt="THE ERNE medal — Take the leap" draggable={false}
            className="relative block w-full drop-shadow-[0_40px_60px_rgba(0,0,0,0.65)]"
            style={{ transformOrigin: '50% 0%' }}
            animate={{ rotate: [-2.5, 2.5, -2.5] }} transition={{ duration: 5.5, repeat: Infinity, ease: 'easeInOut' }}
            data-testid="home-erne-medal"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
